import React, { useEffect, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import "./ExpenseBreakdownPageComponent.css"



const ExpenseBreakdownPageComponent = (props) => {
    const [pickExpenses, setPickExpenese] = useState("");

    const expenseList = [
        "Morgage",
        "Rent", 
        "Utilities", 
        "Property Tax", 
        "Education", 
        "Wi-Fi", 
        "Cell Phone", 
        "Car Payments", 
        "Groceries", 
        "Holiday/Travel",
        "Childcare",
        "Pet Care",
        "Health & Fitness",
        "Debt",
        "Entertainment & Recreation",
        "Personal Spending",
        "Home Maintenance",
        "Annual Subscriptions & Memberships",
        "RESP",
        "Other"
    ]

    const onInputChange = (event) => {
        const expenseTypes = event
        setPickExpenese(expenseTypes)
        props.getExpenseTypesData(expenseTypes);
    }

    return (
        <div>
            <Multiselect
                className="dropdown-location"
                placeholder="Select"
                isObject={false}
                onRemove={onInputChange}
                onSelect={onInputChange}
                options={expenseList}
            >
            </Multiselect>
        </div>
    );
};

export default ExpenseBreakdownPageComponent;